import PlanetTransitionScene from '../planetTransitionScene'

export default class IcePlanetTransitionScene extends PlanetTransitionScene {
  constructor() {
    super(
      'IcePlanetTransitionScene',
      'IcePlanetScene',
      'Chapter Two',
      `After searching around for a while and bravely fighting off his natural predators, Frogault
concluded that Froguette was around no longer. He really is lost after all. Did a
Winter Owl perhaps take her by force to the Ice Planet? What if she is held hostage?

Frogault does not like the cold, especially when it's slippery, but he has no
choice other than going forward to the next planet!`
    )
  }
}
